import React from 'react';
import styled from 'styled-components';
import { Box, css, Flex, Text } from '@goodrx/matisse-react';
import { ComponentRenderer, Container } from '@goodrx/x-core';
import { CdnImage } from '../../../../components/CdnImage';
import { Paragraph } from '../../../../components/MarkdownCopy/markdownRenderers/Paragraph';
import { MarkdownCopy } from '../../../../components/MarkdownCopy';
import { mediaMaxWidth } from '../../../../utils';
const HeroWrapper = styled.div`
  ${({
  backgroundColor,
  textColor
}) => css`
    ${backgroundColor ? `background-color: ${backgroundColor}` : null};
    ${textColor ? `color: ${textColor};h1 { color: ${textColor}};` : null};

    ${mediaMaxWidth({
  md: css`
        background-color: white;
      `
})}
  `};

  overflow: hidden;
`;
const HeroText = styled(Flex)`
  & {
    position: relative;
    padding: 48px 0;
    z-index: 2;

    h1 {
      font-size: 44px;
      line-height: 48px;
      margin: 0 0 20px 0;
    }

    p,
    li {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      margin: 0 0 20px 0;
    }
    p span {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
    }
  }

  ${mediaMaxWidth({
  md: css`
      padding: 20px 0;

      h1 {
        font-size: 24px;
        line-height: 28px;
        margin: 0 0 16px 0;
      }

      p,
      p span,
      li {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
      }

      .bodyCopyType_disclosure {
        text-align: center;
      }
    `
})}
`;
const HeroImage = styled(Flex)`
  ${({
  backgroundColor
}) => css`
    ${backgroundColor ? `background-color: ${backgroundColor}` : null};

    margin-left: -16px;
    position: relative;
    z-index: 0;
  `}
`;
const StyledDesktopImage = styled(CdnImage)`
  max-height: 480px;
  ${mediaMaxWidth({
  md: css`
      display: none;
    `
})}
`;
const StyledMobileImage = styled(Flex)`
  display: none;
  ${mediaMaxWidth({
  md: css`
      display: flex;
    `
})}

  img {
    max-height: 192px;
  }
`;
const StyledTitle = styled(Text)`
  font-size: 44px;
  ${mediaMaxWidth({
  md: css`
      font-size: 24px;
    `
})}
`;
const StyledSubtitle = styled(MarkdownCopy)`
  font-size: 20px;

  .imageText {
    font-size: 18px;
  }

  ${mediaMaxWidth({
  md: css`
      font-size: 16px;

      .imageText {
        font-size: 16px;
      }
    `
})}
`;
const StyledCtaContent = styled(Box)`
  margin-top: 40px;

  hr {
    display: none;
    height: 0px;
    border: 0;
    border-bottom: 1px solid #e8e9ea;
  }

  ${mediaMaxWidth({
  md: css`
      margin-top: 20px;
      text-align: center;
      width: 100%;
      hr {
        display: block;
        margin-bottom: 20px;
      }
    `,
  sm: css`
      a {
        max-width: 100%;
      }
    `
})}

  a + a {
    margin-top: 8px;
  }
`;
export function PageHero(props) {
  const {
    componentMap,
    className,
    contentCollection,
    displayTitle,
    designRules,
    subTitle,
    image,
    mobileImage
  } = props;
  const backgroundColor = designRules === null || designRules === void 0 ? void 0 : designRules.backgroundColor;
  const textColor = designRules === null || designRules === void 0 ? void 0 : designRules.textColor;
  const items = (contentCollection === null || contentCollection === void 0 ? void 0 : contentCollection.items.filter(item => !!item)) || [];
  return /*#__PURE__*/React.createElement(HeroWrapper, {
    backgroundColor: backgroundColor,
    className: className,
    textColor: textColor
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: {
      _: 'column-reverse',
      md: 'row'
    },
    flexWrap: "wrap",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(HeroText, {
    alignItems: "center",
    m: 0,
    p: 0,
    width: {
      _: '100%',
      md: '50%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(StyledTitle, {
    as: "h1"
  }, displayTitle), subTitle && /*#__PURE__*/React.createElement(StyledSubtitle, {
    className: className,
    renderers: {
      paragraph: Paragraph
    },
    source: subTitle
  }), /*#__PURE__*/React.createElement(StyledCtaContent, null, /*#__PURE__*/React.createElement("hr", null), items.map((data, index) => /*#__PURE__*/React.createElement(ComponentRenderer, {
    componentMap: componentMap,
    data: data,
    key: `pageHeroContent_${index}`
  }))))), /*#__PURE__*/React.createElement(HeroImage, {
    alignItems: "center",
    backgroundColor: backgroundColor,
    justifyContent: "center",
    width: {
      _: 'calc(100% + 32px)',
      md: '50%'
    }
  }, image && /*#__PURE__*/React.createElement(StyledDesktopImage, {
    alt: image.title || 'Unnamed Image',
    src: `${image.url}`
  }), mobileImage && /*#__PURE__*/React.createElement(StyledMobileImage, {
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(CdnImage, {
    alt: mobileImage.title || 'Unnamed Image',
    height: `${(mobileImage.height || 0) * 0.75}px`,
    src: `${mobileImage.url}`
  }))))));
}